"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/VideoCall/VideoFeed.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _lodash = require('lodash');
var _log = require('shared/log');

var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);










// Was a PureComponent: memo keeps the same shallow props bail-out, so a tile
// re-render with the same stream never touches the <video> element.
// The ref callbacks are stable, so they run only when an element mounts or
// unmounts (a new callback per render would re-attach the stream and make the
// video flicker). Mount, update and unmount work runs in layout effects, like
// componentDidMount/DidUpdate/WillUnmount.
const VideoFeed = _react.memo.call(void 0, function VideoFeed ({
  stream,
  className,
  wrapperClassName,
  isVideoOn = true,
  isCover,
  shouldMirror = false,
}) {
  const [shouldCover, setShouldCover] = _react.useState.call(void 0, false)

  const rootRef = _react.useRef(null)
  const videoDOM = _react.useRef(null)
  // `this.props.stream` for the stable callbacks. An insertion effect runs
  // before React attaches refs, so a <video> mounting in this render (video
  // turned back on) is attached to this render's stream, as in the class.
  const latestStream = _react.useRef.call(void 0, stream)
  _react.useInsertionEffect.call(void 0, () => { latestStream.current = stream })
  const prevStream = _react.useRef.call(void 0, stream)
  const isMounted = _react.useRef.call(void 0, false)

  const setRootRef = _react.useCallback.call(void 0, (r) => { rootRef.current = r }, [])

  const cleanup = _react.useCallback.call(void 0, () => {
    if (!videoDOM.current) return
    videoDOM.current.src = ''
    videoDOM.current.load()
  }, [])

  const updateStreamSrc = _react.useCallback.call(void 0, () => {
    const currentStream = latestStream.current
    cleanup()
    if (videoDOM.current && currentStream) {
      videoDOM.current.srcObject = currentStream
      const played = videoDOM.current.play()
      if (played !== undefined) {
        played.catch(e => _log.log.info("Couldn't play video", e))
      }
    }
  }, [cleanup])

  const initStreamPlayback = _react.useCallback.call(void 0, (r) => {
    videoDOM.current = r
    updateStreamSrc()
  }, [updateStreamSrc])

  const updateShouldCover = _react.useCallback.call(void 0, () => {
    const currentStream = latestStream.current
    if (!currentStream || !rootRef.current) return
    const track = currentStream.getTracks()[0]
    if (!track) return
    const trackSettings = track.getSettings()

    const containerBounds = rootRef.current.getBoundingClientRect()
    const containerWidth = containerBounds.right - containerBounds.left
    const containerHeight = containerBounds.bottom - containerBounds.top

    const containerRatio = containerWidth / containerHeight
    // SAFETY: an audio track has no width/height; the ratio is then NaN and
    // the check below is false, as in JS.
    const trackRatio = trackSettings.width / trackSettings.height

    setShouldCover(Math.abs(trackRatio - containerRatio) < 0.5)
  }, [])

  // One debounced function per mounted feed, like the class field
  // (updateShouldCover is stable, so the closure never goes stale).
  const [debouncedUpdateShouldCover] = _react.useState.call(void 0, () => _lodash.debounce.call(void 0, updateShouldCover, 200))

  // componentDidMount / componentWillUnmount
  _react.useLayoutEffect.call(void 0, () => {
    window.addEventListener('resize', debouncedUpdateShouldCover)
    updateShouldCover()
    return () => {
      cleanup()
      window.removeEventListener('resize', debouncedUpdateShouldCover)
    }
  }, [debouncedUpdateShouldCover, updateShouldCover, cleanup])

  // componentDidUpdate: after every update, not on mount.
  _react.useLayoutEffect.call(void 0, () => {
    if (!isMounted.current) {
      isMounted.current = true
      return
    }
    const streamChanged = prevStream.current !== stream
    prevStream.current = stream
    updateShouldCover()
    if (streamChanged) { updateStreamSrc() }
  })

  const rootClassName = _classBuilder2.default.call(void 0, 
    className,
    { cover: isCover || shouldCover },
    { mirrored: shouldMirror },
    'meeting--video-feed',
  )
  const containerClassName = _classBuilder2.default.call(void 0, 
    wrapperClassName,
    "meeting--video-feed--wrapper",
  )

  return (
    _react2.default.createElement('div', { ref: setRootRef, className: containerClassName, __self: this, __source: {fileName: _jsxFileName, lineNumber: 124}}
      ,  isVideoOn
        ? _react2.default.createElement('video', {
            playsInline: true,
            autoPlay: true,
            muted: true,
            className: rootClassName,
            ref: initStreamPlayback, __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
          )
        : _react2.default.createElement('div', { className: className, __self: this, __source: {fileName: _jsxFileName, lineNumber: 133}} )
      
    )
  )
})

exports. default = VideoFeed
